export const tr = {
    'feedback-already-exists':
        'Bir uzman için sadece bir yorum bırakılabilir. Lütfen daha önce bıraktığınız yorumunuzu düzenleyin',
    'feedback-not-found': 'Veritabanımızda düzenlenebilir bir yorum bulunamadı. Sayfayı yenileyin ve tekrar deneyin',
    'incorrect-feedback-text-size': 'Bırakacağınız yorum üç karakterden az olamaz.',
    'operator-has-no-project-with-freelancer':
        'Bu uzman ile, devam eden veya tamamlanmış bir çözüm ortaklığınız olmadığı için kendisiyle ilgili yorum bırakamazsınız.',
    'operator-has-wrong-role': 'Yandex.Direct uzmanlarıyla ilgili yorum bırakamazsınız',
    'operator-is-not-chief': 'Yandex.Direct uzmanlarıyla ilgili yorum bırakamazsınız'
};
